import { render } from "./VerifyBadge.vue?vue&type=template&id=2d38e3d6&scoped=true&ts=true"
import script from "./VerifyBadge.vue?vue&type=script&lang=ts"
export * from "./VerifyBadge.vue?vue&type=script&lang=ts"

import "./VerifyBadge.vue?vue&type=style&index=0&id=2d38e3d6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d38e3d6"]])

export default __exports__